import React, { Component } from "react";
import { View, Image, TouchableOpacity,ScrollView } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, componentStyles, settingStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor, yellowDarkColor, yellowLightColor } from "../theme/colors";
import { sectionsRequest, addFeedbackRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import DialogList from "../components/DialogList";
import DialogMessage from "../components/DialogMessage";
import { getError } from "../utils/utils";
import TextInput from "../components/TextInput/TextInput";
import { wp } from "../utils/responsive";
import EditText from "../components/EditText";

export default class SupportScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: '',
            sections: [],
            selectedSection: null,
            content: '',
            waiting: false,
            sectionModal: false,
            showMessage: false,
            messageTitle: '',
            messageContent: '',
            messageSucces: false
        }
    }

    render() {

        return (

            <View style={appStyles.flex1}>
                <View style={appStyles.toolbarWraper}>
                    <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                    <TextView style={appStyles.toolbarTitle}>انتقادات و پیشنهادات</TextView>
                    <TouchableOpacity onPress={() => {
                        this.props.navigation.goBack()
                    }}>
                        <Image source={icons['back']} style={appStyles.backIcon} />
                    </TouchableOpacity>
                </View>
                <LinearGradient colors={[blueDarkColor, blueLightColor]} style={settingStyles.wraper}>

                    <ScrollView contentContainerStyle={{ width: wp(100), alignItems: 'center' }} enableOnAndroid={true} keyboardShouldPersistTaps='handled'>
                        <TextView style={{ textAlign: 'center', color: 'white' }}>انتقاد و پیشنهادات خود را برای ما ارسال کنید</TextView>

                        <EditText
                            hint='موضوع پیام'
                            mode='outlined'
                            hintColor={'white'}
                            textStyle={{ color: 'white', width: wp(90) }}
                            inputType='numeric'
                            style={appStyles.textInput}
                            onChangeText={(text) => {
                                this.setState({
                                    title: text
                                })
                            }}
                            value={this.state.title}
                        />
                        <TouchableOpacity style={[appStyles.whitetextInput, { flexDirection: 'row', justifyContent: 'space-between', paddingLeft: 20, paddingRight: 20 }]}
                            onPress={() => {
                                this.setState({
                                    sectionModal: true
                                })
                            }}>
                            <Image source={icons['dropdown']} style={appStyles.backIcon} />
                            <TextView>{this.state.selectedSection != null ? this.state.selectedSection.name : 'انتخاب بخش'}</TextView>

                        </TouchableOpacity>
                        <EditText
                            hint='متن پیام'
                            mode='outlined'
                            multiline={true}
                            hintColor={'white'}
                            textStyle={{ color: 'white', width: wp(90) }}
                            style={appStyles.textInput}
                            onChangeText={(text) => {
                                this.setState({
                                    content: text
                                })
                            }}
                            value={this.state.content}
                        />
                        <TouchableOpacity style={{ alignSelf: 'center', margin: 20 }} activeOpacity={0.5} onPress={() => {
                            if (this.state.selectedSection != null && this.state.title.length > 0 && this.state.content.length > 0) {
                                this.setState({
                                    waiting: true
                                })
                                addFeedbackRequest(this.state.title, this.state.content, this.state.selectedSection.id, (isConnect, response) => {
                                    this.setState({
                                        waiting: false
                                    })
                                    if (isConnect && response.isSuccess) {
                                        this.setState({
                                            showMessage: true,
                                            messageContent: response.message,
                                            messageSucces: true
                                        })
                                    } else {
                                        this.setState({
                                            showMessage: true,
                                            messageContent: getError(response),
                                            messageSucces: false
                                        })
                                    }
                                })
                            }

                        }}>
                            <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[yellowLightColor, yellowDarkColor]} style={[componentStyles.gradinatButton, { width: 150, height: 50, borderRadius: 25 }]}>
                                <TextView style={{ color: 'white' }}>ارسال پیام</TextView>
                            </LinearGradient>
                        </TouchableOpacity>
                    </ScrollView>
                </LinearGradient>
                <DialogList
                    show={this.state.sectionModal}
                    title='انتخاب بخش'
                    field='name'
                    data={this.state.sections}
                    onSelect={(item) => {
                        this.setState({
                            sectionModal: false,
                            selectedSection: item,
                        })

                    }}
                    onCancel={() => {
                        this.setState({
                            sectionModal: false
                        })
                    }} />
                <DialogMessage
                    show={this.state.showMessage}
                    title={this.state.messageTitle}
                    message={this.state.messageContent}
                    onClose={() => {
                        this.setState({
                            showMessage: false
                        })
                        if (this.state.messageSucces) {
                            this.props.navigation.goBack()
                        }
                    }} />
                <Waiting waiting={this.state.waiting} />

            </View>
        )
    }

    componentWillMount() {
        sectionsRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    sections: response.data
                })
            }
        })
    }

}
